import React from "react";

const EventStatsCard = ({
  title,
  value,
  icon: Icon,
  color = "purple",
}) => {
  const colorClasses = {
    purple: {
      iconBg: "bg-purple-50",
      iconColor: "text-purple-600",
      valueColor: "text-purple-600",
    },
    blue: {
      iconBg: "bg-blue-50",
      iconColor: "text-blue-600",
      valueColor: "text-blue-600",
    },
    green: {
      iconBg: "bg-green-50",
      iconColor: "text-green-600",
      valueColor: "text-green-600",
    },
    orange: {
      iconBg: "bg-orange-50",
      iconColor: "text-orange-600",
      valueColor: "text-orange-600",
    },
    gray: {
      iconBg: "bg-gray-50",
      iconColor: "text-gray-600",
      valueColor: "text-gray-900",
    },
  };

  const colors = colorClasses[color] || colorClasses.purple;

  return (
    <div className="p-4 bg-white rounded-xl border border-gray-100 shadow-sm transition-all duration-300 sm:rounded-2xl sm:p-5 lg:p-6 hover:shadow-lg hover:-translate-y-1">
      <div className="flex justify-between items-center">
        <div className="flex-1 min-w-0">
          <p className="mb-1 text-xs font-medium text-gray-600 truncate sm:text-sm">
            {title}
          </p>
          <p className={`text-xl font-bold sm:text-2xl lg:text-3xl ${colors.valueColor}`}>
            {value}
          </p>
        </div>
        <div className={`flex-shrink-0 p-3 ml-3 rounded-xl sm:p-3 ${colors.iconBg}`}>
          <Icon className={`w-5 h-5 sm:w-6 sm:h-6 lg:w-7 lg:h-7 ${colors.iconColor}`} />
        </div>
      </div>
    </div>
  );
};

export default EventStatsCard;

